import AboutSection from "../components/AboutSection";
import ProgressTrackerSection from "../components/ProgressTrackerSection";
import TrustSectiion from "../components/TrustSectiion";
import WhyChooseUs from "../components/WhyChooseUs";
import CommitmentSection from "../components/CommitmentSection";
import { Helmet } from "react-helmet-async";
import useAppData from "../hooks/useAppData";

const About = () => {
	const { aboutPage } = useAppData();
	return (
		<>
			<Helmet>
				<title>{aboutPage.meta_title}</title>
				<meta name="description" content={aboutPage.meta_description} />
				<meta name="keywords" content={aboutPage.meta_keywords} />
			</Helmet>
			<div>
				<div className="about-banner">
					<img src="assets/images/banners/about-us-banner.jpg" alt="" />
					<h3 className="text-uppercase Ethnocentric ">
						Welcome to the bluedart express dubai
					</h3>
				</div>
				<div className=" container ">
					<AboutSection isAboutPage={true} />
					<WhyChooseUs />
					<ProgressTrackerSection />
				</div>
				<CommitmentSection />
				<div style={{ backgroundColor: "#dfdfdf" }}>
					<TrustSectiion />
				</div>
			</div>
		</>
	);
};

export default About;
